import React, { useMemo } from 'react';
import { classNames } from '@src/utils';
import './children-block.scss';
import ItemBlock from '../item-block';
var prefixCls = 'children-block';
var ChildrenBlock = function (props) {
    var className = useMemo(function () { return classNames(prefixCls, props.data.sysTypeID); }, [props.data.sysTypeID]);
    var data = props.data;
    return (React.createElement("div", { className: className, style: props.style },
        React.createElement("div", { className: prefixCls + "_title" },
            React.createElement("span", null,
                " ",
                data.sysTypeName),
            data.sysTypeEnglish ? React.createElement("span", null,
                " / ",
                data.sysTypeEnglish) : ''),
        React.createElement("div", { className: prefixCls + "_children" }, data.children.map(function (item) { return (React.createElement(ItemBlock, { data: item, key: item.sysID, onClickItemBlock: props.onClickItemBlock })); })),
        React.createElement("hr", null)));
};
export default React.memo(ChildrenBlock, function (prev, next) {
    return prev.data.sysTypeID !== next.data.sysTypeID;
});
